import { FC, lazy, Suspense } from 'react';

const AuthModal = lazy(() => import('./auth-modal/auth-modal').then(m => ({ default: m.AuthModal })));
const GetStartedModal = lazy(() => import('@/components/shared/modals/auth-modal').then(m => ({ default: m.GetStartedModal })));
const PaywallModal = lazy(() => import('./paywall/paywall').then(m => ({ default: m.PaywallModal })));
const FeatureGateModal = lazy(() => import('./feature-gate/feature-gate-modal').then(m => ({ default: m.FeatureGateModal })));
const CheckoutModal = lazy(() => import('./checkout-modal/checkout-modal').then(m => ({ default: m.CheckoutModal })));
const UpdateCardModal = lazy(() => import('./update-card-modal/update-card-modal').then(m => ({ default: m.UpdateCardModal })));
const AdminB2BModal = lazy(() => import('./admin-b2b-modal').then(m => ({ default: m.AdminB2BModal })));

export const ModalContainer: FC = () => {
  return (
    <Suspense fallback={null}>
      <AuthModal />
      <GetStartedModal />
      <PaywallModal />
      <FeatureGateModal />
      <CheckoutModal />
      <UpdateCardModal />
      <AdminB2BModal />
    </Suspense>
  );
};
